module.exports = __webpack_public_path__ + "img/558.ee0b8233.jpg";